import styled from 'styled-components';

export const PhoneInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const CountrySelect = styled.select`
  padding: 12.5px 28px 12.5px 10px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)'};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  font-size: 14px;
  outline: none;
  cursor: pointer;
  min-width: 90px;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='${(
    props
  ) =>
    props.theme.name === 'dark'
      ? '%23ffffff'
      : '%231F2937'}'%3e%3cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  transition: border-color 0.2s;

  option {
    background: #1f2937;
  }

  &:focus {
    border-color: ${(props) => props.theme?.colors?.primary || '#FA4616'};
  }
`;

export const PhoneNumberInput = styled.input`
  flex: 1;
  padding: 12.5px 12px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)'};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${(props) => props.theme?.colors?.primary || '#FA4616'};
  }

  &::placeholder {
    color: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.4)'
        : 'rgba(0, 0, 0, 0.4)'};
  }

  /* Fix autofill background color in dark theme */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px
      ${(props) =>
        props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'}
      inset !important;
    -webkit-text-fill-color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : '#1F2937'} !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;
